/**
 * Import Dependency
 */
import Vue from 'vue'

import File from '@/models/File.js'

/**
 * Import API
  files: [
  ]
 */

/**
 * Declare Variable
 */
 const state = {
  /**
   * List of File records by uuid
   */
  filesByUuid: {},

  /**
   * Loading
   */
  isLoadingByUuid: {},

  /**
   * Failed
   */
  hasFailedByUuid: {},
}

const getters = {
  /**
   * Check whether a specific file is available
   *
   * @returns {boolean}
   */
  isFileAvailable: (state) => ({ uuid }) => !! state.filesByUuid[uuid],

  /**
   * Obtain a file record by uuid
   *
   * @returns {boolean}
   */
  getFileByUuid: state => ({ uuid }) => state.filesByUuid[uuid] || null,

  /**
   * Get whether the file failed to load
   */
  getFileFailedToLoad: state => ({ uuid }) => (!! state.hasFailedByUuid[uuid]) || false,

  /**
   * Get whether the file is currently being loaded
   */
  getFileIsLoading: state => ({ uuid }) => (!! state.isLoadingByUuid[uuid]) || false,
}
const actions = {


  loadFilesByChargingPointRequest: async ({ getters, commit }, { uuid }) => {
    console.log(getters, commit, uuid)
    // TODO: Implement
    // TODO: `${process.env.VUE_APP_CBAPI_BASE_URL}/v1/${tenantSlug}/charging-point-requests/${uuid}/files`,
  },

  /**
   * Get a single use temporary url to the file
   *  This url won't be stored, as it isn't re-useable
   */
  async getFileLinkByUuid(_, { uuid }) {
    try {
      // Get the download link
      const response = await this.$cbapi.files.getDownloadLinkByUuid({
        uuid
      })

      // TODO: CBAPI - update file data if outdated ?

      return response?.link || false
    } catch(e) {
      return false
    }
  },

  /**
   * Load a File record from the central API by uuid
   */
   async loadFileInformationByUuid({ getters, commit }, { uuid, force }) {

    if (! uuid) return

    // No need to load a file twice, unless we want to force it
    force = [true, false].includes(force) ? force : false
    if (force !== true && getters.isFileAvailable({ uuid })) {
      return
    }

    // File is already loading
    if (getters.getFileIsLoading({ uuid })) {
      return
    }

    commit('setFileIsLoadingByUuid', {
      uuid, loading: true,
    })

    try {
      const response = await this.$cbapi.files.getInformationByUuid({
        uuid
      })

      // Handle error
      if (! response) {
        commit('setFileHasFailedStatusByUuid', {
          uuid, failed: true,
        })
        commit('setFileIsLoadingByUuid', {
          uuid, loading: false,
        })

        return false
      }

      // const response = await api.json()

      commit('setFileByUuid', {
        file: response?.data,
      })

      // File no longer failed
      if (getters.getFileFailedToLoad({ uuid })) {
        commit('setFileHasFailedStatusByUuid', {
          uuid, failed: false,
        })
      }

      commit('setFileIsLoadingByUuid', {
        uuid, loading: false,
      })

    } catch (e) {
      // Register failure
      commit('setFileHasFailedStatusByUuid', {
        uuid, failed: true,
      })
      commit('setFileIsLoadingByUuid', {
        uuid, loading: false,
      })
    }
  },
}
const mutations = {
  /**
   * Set a file record by it's uuid
   */
  setFileByUuid(state, { file }) {
    Vue.set(state.filesByUuid, file.uuid, Object.freeze(new File(file)))
  },

  /**
   * Set whether the file has failed loading
   */
  setFileHasFailedStatusByUuid(state, { uuid, failed }) {
    Vue.set(state.hasFailedByUuid, uuid, !! failed)
  },

  /**
   * Whether the file is loading
   */
  setFileIsLoadingByUuid(state, { uuid, loading }) {
    Vue.set(state.isLoadingByUuid, uuid, !! loading)
  },
}

/**
 * Export
 */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
